import { Router } from '@angular/router';
import { EnvironmentService } from './../services/environment/environment.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private token: string = null;

    constructor(
        private auth: AuthService,
        private env: EnvironmentService,
        private router: Router
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token: string = this.auth.getAccessToken();
        const venue_id: string | number | null = this.env.api.venue_id || null;

        // ✅ Use your helper instead of old manual checks
        const isApiRequest = this.env.isApiUrl(request.url);

        if (isApiRequest) {
            if (token) {
                request = request.clone({
                    headers: request.headers.set('Authorization', 'Bearer ' + token)
                });
            }

            if (!token && this.token) {
                request = request.clone({
                    headers: request.headers.set('Authorization', 'Bearer ' + this.token)
                });
                this.token = null;
            }

            if (venue_id) {
                request = request.clone({
                    headers: request.headers.set('X-Venue-ID', String(venue_id))
                });
            }
        }

        this.token = token;

        return next.handle(request);
    }
}
